import { Injectable } from '@angular/core';
import { LeanNetworkService } from 'src/app/tools/services/lean-network-service';
import { UserService } from 'src/app/assabil-kernel/services/user-service';
import { BaseRequest } from 'src/app/tools/models/dtos/base-request';
import { Pack } from '../models/entities/pack';



@Injectable({
  providedIn: 'root'
})
export class PackingPorderService {

  constructor(private networkService: LeanNetworkService,  public userService : UserService) { }

  
  //-----------------------------------------------------------------------------------------------------
   addPackToPorder(porderCode: string, productCode : string, packCode: string) : Promise<Pack>{
        let request: BaseRequest = new BaseRequest(this.userService.userInfo);
        request.code      = porderCode;
        request.strArg1   = productCode;
        request.strArg2   = packCode;


        return new Promise((resolve, reject) => {
            this.networkService.post('packing/addPackToPorder', request).then(result => {
                return resolve(result.pack);
            });
        });
    }
  //-----------------------------------------------------------------------------------------------------


}


